<div class="testing-push-container p-6 max-w-2xl mx-auto">
    <h2 class="text-xl font-bold mb-4">Camera Push Test</h2>
    <form (ngSubmit)="testPushCamera()" #pushCameraForm="ngForm" class="mb-8">
        <div class="mb-2">
            <label class="block text-sm font-medium mb-1">Camera ID (Vzenith/PushCamera):</label>
            <input type="text" class="border rounded px-2 py-1 w-full" [(ngModel)]="pushCameraId" name="pushCameraId"
                required />
        </div>
        <div class="mb-2">
            <label class="block text-sm font-medium mb-1">Payload (JSON):</label>
            <textarea class="border rounded px-2 py-1 w-full" [(ngModel)]="pushCameraPayload" name="pushCameraPayload"
                rows="3"></textarea>
        </div>
        <jjames-button variant="primary" type="submit">Test Push Camera</jjames-button>
        @if (pushCameraResult) {
        <div class="mt-2 text-xs text-green-700">Result: {{ pushCameraResult }}</div>
        }
    </form>

    <h2 class="text-xl font-bold mb-4">Dahua ITC Push Test</h2>
    <form (ngSubmit)="testItcPush()" #itcPushForm="ngForm">
        <div class="mb-2">
            <label class="block text-sm font-medium mb-1">Gate ID (query):</label>
            <input type="number" class="border rounded px-2 py-1 w-full" [(ngModel)]="itcGateId" name="itcGateId" />
        </div>
        <div class="mb-2">
            <label class="block text-sm font-medium mb-1">IP (query):</label>
            <input type="text" class="border rounded px-2 py-1 w-full" [(ngModel)]="itcIp" name="itcIp" />
        </div>
        <div class="mb-2">
            <label class="block text-sm font-medium mb-1">Direction (query):</label>
            <input type="text" class="border rounded px-2 py-1 w-full" [(ngModel)]="itcDirection" name="itcDirection" />
        </div>
        <div class="mb-2">
            <label class="block text-sm font-medium mb-1">Payload (JSON):</label>
            <textarea class="border rounded px-2 py-1 w-full" [(ngModel)]="itcPayload" name="itcPayload"
                rows="3"></textarea>
        </div>
        <jjames-button variant="secondary" type="submit">Test ITC Push</jjames-button>
        @if (itcPushResult) {
        <div class="mt-2 text-xs text-green-700">Result: {{ itcPushResult }}</div>
        }
    </form>
</div>